export const KG_PER_LB = 0.45359237;

export const CM_PER_IN = 2.54;

export const MM_IN_CM = 10;

export const MM_IN_M = 1000;

export const GRAMS_IN_KG = 1000;
